import css from 'styled-jsx/css';

export default css`
  .topic-card {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 25px;
    padding: 0 24px;
    width: 275px;
    height: 68px;
    background-color: #141414;
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid transparent;
    transition: border 0.3s ease-in-out;
  }
  .topic-card:hover {
    border: 1px solid #a50000;
  }
  .topic-card-icon {
    width: 39px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 767px) {
    .topic-card-icon {
      width: 30px;
      height: 30px;
    }
  }
  .topic-card-title {
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    font-family: 'Roboto-Normal';
    letter-spacing: 0;
  }
  @media (max-width: 921px) {
    .topic-card {
      justify-content: flex-start;
      gap: 10px;
      font-size: 10px;
      max-width: 200px;
      padding: 10px;
      text-align: center;
    }
  }
  @media (max-width: 767px) {
    .topic-card {
      flex-direction: column;
      justify-content: flex-start;
      font-size: 10px;
      width: 100px;
      height: 100px;
      padding: 15px 10px 10px;
      text-align: center;
    }
    .topic-card-title {
      display: block;
      width: 100%;
      padding: 0 5px;
      margin: 0;
      font-size: 10px;
    }
  }
`;
